module.exports = __webpack_public_path__ + "static/media/makeover_brand_banner.955984fd.jpg";